import { render, staticRenderFns } from "./CreateChapterBookView.vue?vue&type=template&id=23d2c309&scoped=true"
import script from "./CreateChapterBookView.vue?vue&type=script&lang=js"
export * from "./CreateChapterBookView.vue?vue&type=script&lang=js"
import style0 from "./CreateChapterBookView.vue?vue&type=style&index=0&id=23d2c309&prod&scoped=true&lang=css"
import style1 from "./CreateChapterBookView.vue?vue&type=style&index=1&id=23d2c309&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d2c309",
  null
  
)

export default component.exports